var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex h-full w-full flex-1 bg-white"},[_c('div',{staticClass:"duration-250 relative hidden w-0 flex-1 items-center bg-[url('assets/images/onboarding_background.jpeg')] bg-cover bg-center bg-no-repeat p-6 transition ease-in-out",class:{
      'lg:flex': !_setup.useCenteredLayout,
    }},[_c(_setup.OnboardingScreen,{attrs:{"show-back-button":false}})],1),_vm._v(" "),_c('div',{staticClass:"flex w-full flex-1 flex-col justify-center !px-4 !py-8 sm:!px-6 lg:!px-20 xl:!px-24",class:{
      'lg:w-fit lg:flex-none': !_setup.useCenteredLayout,
    }},[_c(_setup.SignUpForm)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }